import React, { createContext, useEffect, useState } from 'react';


export const Mycontext = createContext();

export const ContextProvider = ({ children }) => {
  const [formToShow, setFormToShow] = useState(null);// "formA" | "formB" | null
  const [checkOutData, setCheckOutData] = useState({})
  const [creditBalance, setCreditBalance] = useState(null);
  const [hotelName, setHotelName] = useState('');
  const [creditToupdate,setCreditToupdate ] = useState(false)

 useEffect(() => {
  const role = localStorage.getItem("role");
  if ( role !== "superAdmin" ) {
    setCreditToupdate(true);
  } 
}, []);

  const checkExtension = (formType) => {
      setFormToShow(formType);
  };

  const updateCredit = (creditData) => {
    setCreditBalance(creditData.creditBalance);
    setHotelName(creditData.hotelName);
  };


  const contextval = { checkExtension,formToShow, setFormToShow, checkOutData, setCheckOutData ,creditBalance,
    setCreditBalance,
    hotelName,
    setHotelName,
    updateCredit,creditToupdate,setCreditToupdate
  }

  return (
    <Mycontext.Provider value={contextval}>
      {children}
    </Mycontext.Provider>
  );
}
